var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6009 3.96201C13.6572 4.55606 15.4121 5.87179 16.5241 7.65304C17.6361 9.43429 18.0255 11.5536 17.6166 13.5983C17.2076 15.6429 16.0296 17.4667 14.3118 18.7145C12.594 19.9622 10.4594 20.5447 8.32358 20.3484C6.18778 20.1521 4.20365 19.1912 2.75748 17.6527C1.31131 16.1142 0.506603 14.1082 0.50004 12.0254C0.493478 9.94248 1.28552 7.93178 2.72197 6.38471C4.15842 4.83765 6.13646 3.86495 8.27098 3.65601",
    stroke: "#14AE5C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9453 6.70093C18.9636 8.29177 19.502 10.1279 19.4996 12.0009",
    stroke: "#14AE5C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2188 3.229C15.0454 3.67442 15.8053 4.22755 16.4775 4.873",
    stroke: "#14AE5C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41726 20.3869C2.83398 20.0212 2.28985 19.5998 1.79297 19.1289",
    stroke: "#14AE5C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5075 9.06495L3.7627 23.321L10.4226 11.579H4.37657L9.73559 0.678955H13.6228L8.4615 9.06495H14.5075Z",
    stroke: "#14AE5C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/Power_icon.f5ca67e7f53fb58ef0577d67ef511df6.svg";
export { ForwardRef as ReactComponent };